import { Component } from '@angular/core';

import { SUBREGION_KIND } from '../../../../models/content';
import { SuburbCatalogueService } from '../workspace/catalogue.service';
import { ContentRecordsService } from '../workspace/content-records.service';
import { PageEditorService } from '../workspace/page-editor.service';
import { WorkspaceStateService } from '../workspace/workspace-state.service';

/**
 * "Places and other pages" (#256, #260): the pages that aren't one ABS suburb or a sub-region (places such as a
 * memorial park, and pages not typed yet). Each can be typed (a sub-region moves under its region) or edited; new place
 * pages start here.
 */
@Component({
  selector: 'app-suburb-other-pages',
  templateUrl: './suburb-other-pages.component.html',
  styleUrls: ['./suburb-other-pages.component.scss'],
})
export class SuburbOtherPagesComponent {
  readonly kinds = [
    { label: 'Sub-region', value: SUBREGION_KIND },
    { label: 'Place', value: 'place' },
  ];

  constructor(
    public state: WorkspaceStateService,
    public catalogue: SuburbCatalogueService,
    public records: ContentRecordsService,
    public pageEditor: PageEditorService
  ) {}
}
